import { replace } from 'react-router-redux';
import { Auth,Cache,API } from 'aws-amplify';

let apiName = 'SmartDeviceAPI';
const _category = 'postData';
let bindPath = '/bind';
let registerPath= '/registration';

const startRequest = category => ({
    type: 'START_REQUEST',
    payload: { category }
});

const receiveData = (category, error, response) => ({
    type: 'RECEIVE_DATA',
    payload: { category, error, response }
});

const finishRequest = category => ({
    type: 'FINISH_REQUEST',
    payload: { category }
});

const startRegisterRequest = (category, totalResults,serialnumber,name,comment) => ({
    type: 'START_POST',
    payload: { category, totalResults,serialnumber,name,comment }
});

const finishRegisterRequest = (category, totalResults,serialnumber,name,comment, err) => ({
    type: 'FINISH_POST',
    payload: { category, totalResults,serialnumber,name,comment,err }
});

export const fetchList = (serialnumber, devicename) => {
  return async (dispatch, getState) => {
    const category = 'detect';
    
    const user = Auth.user;
    console.log(user);

    dispatch(startRequest(category));

    const myInit = {
      response: true, // OPTIONAL (return entire response object instead of response.data)
    };

    API.get(apiName, bindPath + '?devicename=' + devicename + serialnumber, myInit).then(response => {
      const data = response.data;
      dispatch(receiveData(category, null, data));
    }).catch(err => {
      console.log(err.response)
      dispatch(receiveData(category, err));
    });

    dispatch(finishRequest(category));
  };
};

export const postData = (checked) => {
  return async (dispatch, getState) => {
    if (typeof checked === 'undefined') {
      dispatch(replace('/'));
      return;
    }

    let user = Auth.user.id;
    if (user === undefined) {
        user = Auth.user.username;
        Cache.getItem('federatedInfo').then(federatedInfo => {
             const { token } = federatedInfo;
             console.log(token);
        });
    }
    console.log(user);

    dispatch(startRegisterRequest(_category, checked.serialnumber));
    const result = [ checked ];
    const myInit = {
      body: {
        userid: user,
        result: result
      },
      headers: {'content-type': 'application/json'}
    };

    API.post(apiName, registerPath, myInit).then(response => {
      dispatch(finishRegisterRequest(_category, checked.serialnumber, null));
    }).catch(err => {
      console.log(err.response)
      dispatch(finishRegisterRequest(_category, checked.serialnumber, err));
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/ThetaDetecting.js